import { useCallback, useEffect, useState } from 'react';
import type { AuthStatus } from '@alfred/shared';
import { api, describeError, setUnauthenticatedHandler } from './api.js';
import { Main } from './MainView.js';
import { SignIn } from './SignIn.js';
import { RingOrb } from './RingOrb.js';

export function App() {
  const [auth, setAuth] = useState<AuthStatus | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    api
      .authStatus()
      .then((s) => {
        setAuth(s);
        setError(null);
      })
      .catch((err: unknown) => setError(describeError(err)));
  }, []);

  useEffect(() => {
    setUnauthenticatedHandler(() => setAuth((a) => (a ? { ...a, signedIn: false } : a)));
    refresh();
  }, [refresh]);

  if (error && !auth) {
    return (
      <div className="center-screen">
        <RingOrb state="idle" showLabel={false} />
        <p className="muted">Can’t reach Alfred: {error}</p>
        <button className="btn" onClick={refresh}>
          Try again
        </button>
      </div>
    );
  }
  if (!auth) {
    return (
      <div className="center-screen">
        <RingOrb state="thinking" showLabel={false} />
      </div>
    );
  }
  if (!auth.signedIn) return <SignIn registered={auth.registered} onSignedIn={refresh} />;
  return <Main onSignedOut={refresh} />;
}
